import * as React from "react";
import en from "../Language/en";
import th from "../Language/th";
import Config from "../Config";

let LangContext = React.createContext();

// let initialState = {
//   locale: "en",
//   data: en
// };

const ChangeLang = (lang) => {
  if (lang === "th") {
    localStorage.setItem("Lang", lang);
    return { locale: lang, data: th, title: Config.sitenameTH };
  } else {
    localStorage.setItem("Lang", lang);
    return { locale: lang, data: en, title: Config.sitenameEN };
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case "CHANG_LANGUAGE":
      return ChangeLang(action.locale);
    default:
      return state;
  }
};

const checkTheme = (lang) => {
  if (lang === "th") {
    return {
      locale: "th",
      data: th,
      title: Config.sitenameTH,
    };
  } else {
    return {
      locale: "en",
      data: en,
      title: Config.sitenameEN,
    };
  }
};

const LangContextProvider = (props) => {
  let [state, dispatchLang] = React.useReducer(
    reducer,
    checkTheme(
      localStorage.getItem("Lang") === null
        ? "th"
        : localStorage.getItem("Lang")
    )
  );
  let value = { lang: state, langDispatch: dispatchLang };
  return (
    <LangContext.Provider value={value}>{props.children}</LangContext.Provider>
  );
};

let LangContextConsumer = LangContext.Consumer;

export { LangContext, LangContextProvider, LangContextConsumer };

export const changeLang = (lang) => ({
  type: "CHANG_LANGUAGE",
  locale: lang,
});
